import React from 'react';


const EpidemicOverlay = () =>
  <div className="overlay epidemic-overlay">
    <div className="banner">
      <div className="text">Epidemic</div>
    </div>
  </div>;

export default EpidemicOverlay;



/** WEBPACK FOOTER **
 ** ./src/components/overlays/EpidemicOverlay.js
 **/